import exceljs from "exceljs";
import moment from "moment";
import { saveAs } from "file-saver";
import i18n from "@/plugins/vue-i18n";
export class ExportDigitalMeterLog {
  constructor() {
    // excel file type
  }
  static async saveFile(workbook, fileName) {
    const buffer = await workbook.xlsx.writeBuffer();
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const fileExtension = ".xlsx";
    const blob = new Blob([buffer], { type: fileType });
    return saveAs(blob, fileName + fileExtension);
  }

  static async exportDigitalMeterLog(records, date){
    const workbook = new exceljs.Workbook();
    const worksheet = workbook.addWorksheet("log");
    worksheet.columns = [
      {
        header: i18n.t('market.market'),
        key: 1,
        width: 30,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: `${i18n.t('time')} (${i18n.t('timeunit.minute.short')})`,
        key: 2,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.space'),
        key: 3,
        width: 15,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('meter.meter_name'),
        key: 4,
        width: 15,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('unit'),
        key: 5,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
    ]

    for(let record of records){
      worksheet.addRow({
        1: record.meter.market.name,
        2: moment(record.dateTime).format("H.mm"),
        3: record.meter.area.name,
        4: record.meter.isMain ? i18n.t('main') : record.meter.name,
        5: record.unit
      })
    }

    return this.saveFile(workbook, `meter-log-${moment(date).format("D-MM-YYYY")}`);
  }
}